
export default {
 name: "CertImage",
 props: {
    id: {
        default: '',
        type: String,
    },
    bg: {
        default: 'https://cdn-wp.tefl.org/wp-content/themes/tefl/img/team_mask1.png',
        type: String
    },
    img: {
        default: 'https://cdn-wp.tefl.org/wp-content/uploads/2022/05/CERT_SAMPLE-2022.png',
        type: String
    },
    alt: {
        default: '',
        type: String
    }
 },
 data() {
    return {

    }
  },
}
